import { render, staticRenderFns } from "./ReservationNote.vue?vue&type=template&id=52ca5fa6&scoped=true"
import script from "./ReservationNote.vue?vue&type=script&lang=js"
export * from "./ReservationNote.vue?vue&type=script&lang=js"
import style0 from "./ReservationNote.vue?vue&type=style&index=0&id=52ca5fa6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ca5fa6",
  null
  
)

export default component.exports